'use strict';

/**
 * @ngdoc controller
 * @name observatoireApp.controller:TitresMinierCtrl
 * @description
 * Contrôleur pour la gestion des titres miniers
 */
angular
  .module('observatoireApp')
  .controller('TitresMinierCtrl', ['$http', '$scope', '$state', 'MetaService', TitresMinierCtrl]);

function TitresMinierCtrl($http, $scope, $state, MetaService) {
  var vm = this;
  
  // Définition des filtres initiaux
  $scope.filtres = {
    texte: '',
    typeTitre: '',
    region: '',
    substance: '',
    statut: '',
    anneeMin: '',
    anneeMax: ''
  };
  
  // Options pour les filtres
  $scope.options = {
    typesTitres: ['Permis d\'exploitation', 'Permis de recherche', 'Autorisation d\'exploitation artisanale', 'Autorisation de carrière'],
    regions: ['Mayo-Kebbi Ouest', 'Guéra', 'Mayo-Kebbi Est', 'Chari-Baguirmi', 'Logone Oriental', 'N\'Djamena'],
    substances: ['Or', 'Argent', 'Diamant', 'Calcaire', 'Granit', 'Marbre', 'Uranium'],
    statuts: ['En vigueur', 'Expiré', 'Renouvelé', 'Suspendu'],
    annees: []
  };
  
  // Générer les années de 2010 à l'année actuelle
  var anneeActuelle = new Date().getFullYear();
  for (var annee = 2010; annee <= anneeActuelle; annee++) {
    $scope.options.annees.push(annee);
  }
  
  // Initialisation des données
  $scope.titresMiniers = [];
  $scope.titresMiniersFilteres = [];
  $scope.loading = {
    titresMiniers: true
  };
  $scope.error = null;
  
  // Configuration de la pagination
  $scope.pagination = {
    pageCourante: 1,
    elementsParPage: 10,
    nombrePages: 1
  };
  
  // Options pour le nombre d'éléments par page
  $scope.optionsElementsParPage = [5, 10, 20, 50, 100];
  
  // S'assurer que elementsParPage est un nombre et pas une chaîne
  $scope.$watch('pagination.elementsParPage', function(newVal) {
    if (typeof newVal === 'string') {
      $scope.pagination.elementsParPage = parseInt(newVal, 10);
    }
    $scope.updatePagination();
  });
  
  // Utilitaire Math pour les templates
  $scope.Math = window.Math;
  
  // Mode d'affichage (table ou map)
  $scope.viewMode = 'table';
  
  // Observer le changement de mode d'affichage
  $scope.$watch('viewMode', function(newMode) {
    if (newMode === 'map') {
      // Laisser le temps au DOM de se mettre à jour avant d'initialiser la carte
      setTimeout(function() {
        initMap();
      }, 300);
    }
  });
  
  // Date formatée
  $scope.formaterDate = function(dateStr) {
    if (!dateStr) return '';
    var date = new Date(dateStr);
    return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
  };
  
  // Méthode pour filtrer les titres miniers
  $scope.rechercherTitresMiniers = function() {
    $scope.loading.titresMiniers = true;
    
    // Construction des paramètres de recherche
    var params = {};
    
    if ($scope.filtres.texte) {
      params.query = $scope.filtres.texte;
    }
    
    if ($scope.filtres.typeTitre) {
      params.typeTitre = $scope.filtres.typeTitre;
    }
    
    if ($scope.filtres.region) {
      params.region = $scope.filtres.region;
    }
    
    if ($scope.filtres.substance) {
      params.substance = $scope.filtres.substance;
    }
    
    if ($scope.filtres.statut) {
      params.statut = $scope.filtres.statut;
    }
    
    if ($scope.filtres.anneeMin) {
      params.anneeMin = $scope.filtres.anneeMin;
    }
    
    if ($scope.filtres.anneeMax) {
      params.anneeMax = $scope.filtres.anneeMax;
    }
    
    // Appel à l'API
    $http.get('/api/titres-miniers/search', { params: params })
      .then(function(response) {
        $scope.titresMiniersFilteres = response.data;
        $scope.loading.titresMiniers = false;
        
        // Réinitialiser la pagination à la première page
        $scope.pagination.pageCourante = 1;
        $scope.updatePagination();
      })
      .catch(function(error) {
        $scope.error = 'Erreur lors de la recherche des titres miniers: ' + error.data;
        $scope.loading.titresMiniers = false;
      });
  };
  
  // Réinitialiser les filtres
  $scope.reinitialiserFiltres = function() {
    $scope.filtres = {
      texte: '',
      typeTitre: '',
      region: '',
      substance: '',
      statut: '',
      anneeMin: '',
      anneeMax: ''
    };
    $scope.chargerTitresMiniers();
  };
  
  // Méthode pour changer de page
  $scope.changerPage = function(numeroPage) {
    // Vérifier les limites
    if (numeroPage < 1 || numeroPage > $scope.pagination.nombrePages) {
      return;
    }
    
    $scope.pagination.pageCourante = numeroPage;
  };
  
  // Méthode pour mettre à jour la pagination
  $scope.updatePagination = function() {
    if (!$scope.titresMiniersFilteres) {
      $scope.pagination.nombrePages = 1;
      return;
    }
    
    $scope.pagination.nombrePages = Math.ceil($scope.titresMiniersFilteres.length / $scope.pagination.elementsParPage);
    
    // S'assurer que la page courante est valide
    if ($scope.pagination.pageCourante > $scope.pagination.nombrePages) {
      $scope.pagination.pageCourante = $scope.pagination.nombrePages || 1;
    }
  };
  
  // Générer les numéros de page à afficher
  $scope.getPages = function() {
    var pages = [];
    var totalPages = $scope.pagination.nombrePages;
    var currentPage = $scope.pagination.pageCourante;
    
    // Afficher jusqu'à 5 pages autour de la page courante
    var startPage = Math.max(1, currentPage - 2);
    var endPage = Math.min(totalPages, startPage + 4);
    
    // Ajuster si on est proche de la fin
    if (endPage - startPage < 4) {
      startPage = Math.max(1, endPage - 4);
    }
    
    for (var i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    
    return pages;
  };
  
  // Méthode pour charger tous les titres miniers
  $scope.chargerTitresMiniers = function() {
    $scope.loading.titresMiniers = true;
    $scope.error = null;
    
    $http.get('/api/titres-miniers')
      .then(function(response) {
        $scope.titresMiniers = response.data;
        $scope.titresMiniersFilteres = response.data;
        $scope.loading.titresMiniers = false;
        
        // Mettre à jour la pagination
        $scope.updatePagination();
        
        // Initialiser la carte si des titres miniers ont des coordonnées géographiques
        setTimeout(function() {
          initMap();
        }, 100);
      })
      .catch(function(error) {
        $scope.error = 'Erreur lors du chargement des titres miniers: ' + error.data;
        $scope.loading.titresMiniers = false;
      });
  };
  
  // Méthode pour afficher les détails d'un titre minier
  $scope.voirDetails = function(id) {
    $state.go('main.titres-miniers-details', { id: id });
  };
  
  // Titre minier sélectionné dans la carte
  $scope.titreSelectionne = null;
  
  // Méthode pour sélectionner un titre minier dans la carte
  $scope.selectionnerTitreMinier = function(titreMinier) {
    $scope.titreSelectionne = titreMinier;
    $scope.$apply();
  };
  
  // Initialiser la carte
  function initMap() {
    if (!$scope.titresMiniersFilteres || $scope.titresMiniersFilteres.length === 0) {
      return;
    }
    
    // Vérifier si l'élément DOM existe
    var mapElement = document.getElementById('titres-map');
    if (!mapElement) {
      console.warn('Élément de carte introuvable dans le DOM');
      return;
    }
    
    try {
      // Vérifier si la variable L (Leaflet) est définie
      if (typeof L !== 'undefined') {
        console.log('Initialisation de la carte Leaflet...');
        
        // Réinitialiser le conteneur de carte pour éviter les problèmes de multiples initialisations
        mapElement.innerHTML = '';
        
        // Centrer la carte sur le Tchad
        var map = L.map('titres-map').setView([15, 19], 5);
        
        // Ajouter la couche OpenStreetMap
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map);
        
        // Ajouter des marqueurs pour chaque titre minier avec coordonnées
        var marquersAjoutes = 0;
        $scope.titresMiniersFilteres.forEach(function(titreMinier) {
          if (titreMinier.latitude && titreMinier.longitude) {
            var lat = parseFloat(titreMinier.latitude);
            var lng = parseFloat(titreMinier.longitude);
            
            if (!isNaN(lat) && !isNaN(lng)) {
              var marker = L.marker([lat, lng])
                .addTo(map)
                .bindPopup(
                  '<strong>' + titreMinier.numeroTitre + '</strong><br>' +
                  'Type: ' + titreMinier.typeTitre + '<br>' +
                  'Société: ' + titreMinier.societe + '<br>' +
                  '<a href="javascript:void(0)" onclick="angular.element(document.getElementById(\'titres-map\')).scope().voirDetails(' + titreMinier.id + ')">Voir détails</a>'
                );
                
              marker.on('click', function() {
                $scope.selectionnerTitreMinier(titreMinier);
              });
              
              marquersAjoutes++;
            }
          }
        });
        
        console.log(marquersAjoutes + ' marqueurs ajoutés à la carte');
        
        // Forcer un recalcul de la taille de la carte après son affichage
        setTimeout(function() {
          if (map) map.invalidateSize();
        }, 500);
      } else {
        console.error('La bibliothèque Leaflet (L) n\'est pas disponible.');
        var errorMsg = document.createElement('div');
        errorMsg.className = 'alert alert-warning';
        errorMsg.innerHTML = '<i class="fa fa-exclamation-triangle"></i> La bibliothèque de cartographie n\'est pas disponible.';
        mapElement.appendChild(errorMsg);
      }
    } catch (e) {
      console.error('Erreur lors de l\'initialisation de la carte:', e);
    }
  }
  
  // Méta-données de la page
  MetaService.setTitle('Titres miniers');
  MetaService.setDescription('Base de données des titres miniers au Tchad');
  
  // Initialisation
  $scope.chargerTitresMiniers();
}
